import SectionHeader from "../ui/SectionHeader";
import PeriodTable from "../ui/PeriodTable";
import AlertBanner from "../ui/AlertBanner";
import KPICard from "../ui/KPICard";
import { fmt, fmtSmall } from "../../formatters";
import { COLORS } from "../../styles";

export default function OverviewTab({ analysis }) {
  const { daily, weekly, monthly, monthToDate, calMonth1, calMonth2, calMonth3, activeLenders, dailyFactorTotal, balanceAlerts } = analysis;
  const balanceCoverage = analysis.currentBalance / (dailyFactorTotal || 1);

  return (
    <div>
      {balanceAlerts.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <SectionHeader title="Active Alerts" badge={`${balanceAlerts.length} FLAGGED`} />
          {balanceAlerts.map((a, i) => <AlertBanner key={i} {...a} />)}
        </div>
      )}
      <SectionHeader title="Period Summary" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
        <PeriodTable data={daily} label="Daily (Last 24h)" />
        <PeriodTable data={weekly} label="Weekly (Last 7 Days)" />
        <PeriodTable data={monthly} label="Rolling 30 Days" />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12, marginBottom: 24 }}>
        <PeriodTable data={monthToDate} label={monthToDate.label} isCalendar />
        <PeriodTable data={calMonth1} label={calMonth1.label} isCalendar />
        <PeriodTable data={calMonth2} label={calMonth2.label} isCalendar />
        <PeriodTable data={calMonth3} label={calMonth3.label} isCalendar />
      </div>
      <SectionHeader title="Key Metrics" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }}>
        <KPICard label="Monthly Revenue" value={fmt(monthly.totalCredits)} sub="Gross deposits (excl. advances)" color={COLORS.green} />
        <KPICard label="Daily Factor Drain" value={fmtSmall(dailyFactorTotal)} sub="Avg/day in loan repayments" color={COLORS.red} />
        <KPICard label="Active Positions" value={activeLenders.length} sub="Lenders w/ active repayments" color={COLORS.blue} />
        <KPICard label="Balance Coverage" value={`${Math.round(balanceCoverage)} days`} sub="At current factor rate" color={balanceCoverage < 3 ? COLORS.red : balanceCoverage < 7 ? COLORS.orange : COLORS.green} />
      </div>
    </div>
  );
}
